import React, {PropTypes} from 'react';
import View from '../cruds/View';
import Edit from '../cruds/Edit';
import Iterate from '../components/container/Iterate';
import {OutputAttachmentRow, OutputAttachmentRowDisabled} from '../components/output/OutputAttachments';
import OutputText, {LocalizedOutputText, OutputBoolean} from '../components/output/OutputText';
import RadioButtonGroup, {RadioButton} from '../components/input/RadioButtonGroup';
import InputSelect from '../components/input/InputSelect';
import ButtonLink from '../components/output/ButtonLink';
import {OutputLink} from '../components/output/OutputLink';
import {Horizontal, HorizontalInput, Vertical, VerticalInput} from '../components/container/LayoutRow';
import {Route, Switch} from 'react-router-dom';
import EvaluationsArchive from './EvaluationsArchive';
import InputText from '../components/input/InputText';
import {notNull, nullValidator, stringNotBlank} from '../cruds/validators';
import './SafetyDataSheetEvaluations.css';
import {FULL_SDS_EVALUATION_ENABLED, ShowBasedOnConfig} from "../components/container/ShowBasedOnConfig";
import {ShowBasedOnCondition} from "../components/container/ShowBasedOnCondition";


const FATHER_ENTITY_ROUTE = 'substances';
const FATHER_ENTITY_NAME = 'substances';
const ENTITY_NAME = 'safetyDataSheetEvaluations';
const ENTITY_ROUTE = 'safetyDataSheetEvaluation';

const CrudEdit = (props, context) => {
    const basePath = buildFullEntity(props.parentId);
    const baseRoute = FATHER_ENTITY_ROUTE;

    const validators = [
        stringNotBlank('clp', 'substances.err.sdsEvaluationClp'),
        notNull('italianSds', 'substances.err.sdsEvaluationItalianSds'),
        context.config[FULL_SDS_EVALUATION_ENABLED] ? notNull('pageNumeration', 'substances.err.sdsEvaluationPageNumeration') : nullValidator(),
        notNull('sectionsCompleted', 'substances.err.sdsEvaluationSectionsCompleted'),
        context.config[FULL_SDS_EVALUATION_ENABLED] ? notNull('sectionsWithoutText', 'substances.err.sdsEvaluationSectionsWithoutText') : nullValidator(),
        context.config[FULL_SDS_EVALUATION_ENABLED] ? notNull('section1', 'substances.err.sdsEvaluationSection1') : nullValidator(),
        context.config[FULL_SDS_EVALUATION_ENABLED] ? notNull('section2', 'substances.err.sdsEvaluationSection2') : nullValidator(),
        notNull('compliantSds', 'substances.err.sdsEvaluationCompliantSds'),
        notNull('usableSds', 'substances.err.sdsEvaluationUsableSds'),
    ];

    return (
        <Edit {...props}
              crudClassName="safetyDataSheets-edit"
              overrideTitle="substances.addSdsEvaluation"
              entityName={basePath}
              entityRoute={baseRoute}
              entityId="new"
              validators={validators}
            /*refreshFrom={basePath + '/evaluate'}*/
              signed
        >

            <Horizontal>
                <OutputText name="substanceCode" label="substances.idCode"/>
                <OutputLink name="sds" label="substances.sds"/>
            </Horizontal>
            <Vertical>
                <Iterate on="attachments" label="substances.attachments">
                    <OutputAttachmentRow/>
                </Iterate>
                <OutputBoolean name="agentMixture" label="agents.mixture"/>
            </Vertical>
            <HorizontalInput style={{alignItems: 'flex-start'}}>

                <VerticalInput style={{flex: 1}}>

                    <InputSelect name="clp" label="substances.sdsEvaluationConsiderationCLPLong"
                                 options={[{
                                     value: 'DANGEROUS',
                                     label: 'substances.sdsEvaluationConsiderationCLPValues.DANGEROUS'
                                 },
                                     {
                                         value: 'NOT_DANGEROUS',
                                         label: 'substances.sdsEvaluationConsiderationCLPValues.NOT_DANGEROUS'
                                     }]} required/>

                    <RadioButtonGroup name="italianSds" label="substances.sdsEvaluationItalianSdsLong" required>
                        <RadioButton value="true" label="hPhrases.atexSubstance.true"/>
                        <RadioButton value="false" label="hPhrases.atexSubstance.false"/>
                    </RadioButtonGroup>
                    <ShowBasedOnConfig configKey={FULL_SDS_EVALUATION_ENABLED} name="pageNumeration">
                        <RadioButtonGroup name="pageNumeration" label="substances.sdsEvaluationPageNumerationLong"
                                          required>
                            <RadioButton value="true" label="hPhrases.atexSubstance.true"/>
                            <RadioButton value="false" label="hPhrases.atexSubstance.false"/>
                        </RadioButtonGroup>
                    </ShowBasedOnConfig>
                    <RadioButtonGroup name="sectionsCompleted" label="substances.sdsEvaluationSectionsCompletedLong"
                                      required>
                        <RadioButton value="true" label="hPhrases.atexSubstance.true"/>
                        <RadioButton value="false" label="hPhrases.atexSubstance.false"/>
                    </RadioButtonGroup>
                    <ShowBasedOnConfig configKey={FULL_SDS_EVALUATION_ENABLED} name="sectionsWithoutText">
                        <RadioButtonGroup name="sectionsWithoutText"
                                          label="substances.sdsEvaluationSectionsWithoutTextLong"
                                          required>
                            <RadioButton value="true" label="hPhrases.atexSubstance.true"/>
                            <RadioButton value="false" label="hPhrases.atexSubstance.false"/>
                        </RadioButtonGroup>
                    </ShowBasedOnConfig>
                    <ShowBasedOnConfig configKey={FULL_SDS_EVALUATION_ENABLED} name="section1">
                        <RadioButtonGroup name="section1" label="substances.sdsEvaluationSection1Long" required>
                            <RadioButton value="true" label="hPhrases.atexSubstance.true"/>
                            <RadioButton value="false" label="hPhrases.atexSubstance.false"/>
                        </RadioButtonGroup>
                    </ShowBasedOnConfig>
                    <ShowBasedOnConfig configKey={FULL_SDS_EVALUATION_ENABLED} name="section2">
                        <RadioButtonGroup name="section2" label="substances.sdsEvaluationSection2Long" required>
                            <RadioButton value="true" label="hPhrases.atexSubstance.true"/>
                            <RadioButton value="false" label="hPhrases.atexSubstance.false"/>
                        </RadioButtonGroup>
                    </ShowBasedOnConfig>
                    <RadioButtonGroup name="compliantSds" label="substances.sdsEvaluationCompliantSdsLong" required>
                        <RadioButton value="true" label="hPhrases.atexSubstance.true"/>
                        <RadioButton value="false" label="hPhrases.atexSubstance.false"/>
                    </RadioButtonGroup>
                    <RadioButtonGroup name="usableSds" label="substances.sdsEvaluationUsableSdsLong" required>
                        <RadioButton value="true" label="hPhrases.atexSubstance.true"/>
                        <RadioButton value="false" label="hPhrases.atexSubstance.false"/>
                    </RadioButtonGroup>
                    <InputText name="note" label="substances.sdsEvaluationNoteLong"/>
                </VerticalInput>


            </HorizontalInput>
        </Edit>
    );
};

CrudEdit.contextTypes = {
    config: PropTypes.object,
};

const ViewButtons = ({entityRoute, entityId}, resource) => (
    <div>
        {/*     <DownloadButton from={'departmentActivitySubstances/evaluations/' + (resource ? resource.departmentActivitySubstanceId : -1)}
        type="application/pdf"
        extension="pdf"
        iconType="button"
        style={{ marginLeft: '10px' }}
    />
    <ButtonLink
        to={'/' + entityRoute}
        label="evaluations.viewArchive"
        style={{ marginLeft: '10px' }}
    /> */}
        <ButtonLink
            to={'/' + FATHER_ENTITY_ROUTE}
            label="general.close"
            style={{marginLeft: '10px'}}
        />
    </div>
);

const buildFullEntity = (parentId) => {
    return [FATHER_ENTITY_NAME, parentId, ENTITY_NAME].join('/');
};

const buildFullRoute = (parentId) => {
    return [FATHER_ENTITY_ROUTE, parentId, ENTITY_ROUTE].join('/');
};

const CrudView = props => (
        <View crudClassName="substances-view" title="substances.sdsEvaluationLong"
              entityName={buildFullEntity(props.parentId)}
              entityRoute={buildFullRoute(props.parentId)}
              entityId={props.match.params.number}
              buttons={ViewButtons}>
            <Horizontal style={{alignItems: 'flex-start'}}>
                <Vertical>
                    <OutputText name="substanceCode" label="substances.idCode"/>

                    <ShowBasedOnCondition evaluateOnField="downloadable" condition={v => v === true}>
                        <OutputText name="sds" label="substances.sds"/>
                    </ShowBasedOnCondition>
                    <ShowBasedOnCondition evaluateOnField="downloadable" condition={v => v === false} name="sds">
                        <OutputText name="sds" label="substances.sds" style={{color: '#c7c7c7'}}/>
                    </ShowBasedOnCondition>
                    <ShowBasedOnCondition evaluateOnField="downloadable" condition={v => v === true}>
                        <Iterate on="attachments" label="substances.attachments">
                            <OutputAttachmentRow/>
                        </Iterate>
                    </ShowBasedOnCondition>
                    <ShowBasedOnCondition evaluateOnField="downloadable" condition={v => v === false}>
                        <Iterate on="attachments" label="substances.attachments">
                            <OutputAttachmentRowDisabled/>
                        </Iterate>
                    </ShowBasedOnCondition>
                </Vertical>
            </Horizontal>
            <Vertical>
                <OutputBoolean name="agentMixture" label="agents.mixture"/>
            </Vertical>
            <Vertical>
                <LocalizedOutputText
                    name="clp"
                    label="substances.sdsEvaluationConsiderationCLPLong"
                    prefix="substances.sdsEvaluationConsiderationCLPValues"
                    style={{marginTop: 10}}
                />
                <OutputBoolean name="italianSds" label="substances.sdsEvaluationItalianSdsLong"/>
                <ShowBasedOnConfig configKey={FULL_SDS_EVALUATION_ENABLED} name="pageNumeration">
                    <OutputBoolean name="pageNumeration" label="substances.sdsEvaluationPageNumerationLong"/>
                </ShowBasedOnConfig>
                <OutputBoolean name="sectionsCompleted" label="substances.sdsEvaluationSectionsCompletedLong"/>
                <ShowBasedOnConfig configKey={FULL_SDS_EVALUATION_ENABLED} name="sectionsWithoutText">
                    <OutputBoolean name="sectionsWithoutText" label="substances.sdsEvaluationSectionsWithoutTextLong"/>
                </ShowBasedOnConfig>
                <ShowBasedOnConfig configKey={FULL_SDS_EVALUATION_ENABLED} name="section1">
                    <OutputBoolean name="section1" label="substances.sdsEvaluationSection1Long"/>
                </ShowBasedOnConfig>
                <ShowBasedOnConfig configKey={FULL_SDS_EVALUATION_ENABLED} name="section2">
                    <OutputBoolean name="section2" label="substances.sdsEvaluationSection2Long"/>
                </ShowBasedOnConfig>
                <OutputBoolean name="compliantSds" label="substances.sdsEvaluationCompliantSdsLong"/>
                <OutputBoolean name="usableSds" label="substances.sdsEvaluationUsableSdsLong"/>
                <OutputText name="note" label="substances.sdsEvaluationNoteLong"/>
            </Vertical>
        </View>
    )
;

const CrudList = props => (
    <EvaluationsArchive entityName={buildFullEntity(props.parentId)}
                        entityRoute={buildFullRoute(props.parentId)}
    />
);

const SafetyDataSheetEvaluation = props => {
    const basePath = props.match.url;
    const parentId = props.match.params.number;

    return (
        <Switch>
            <Route exact path={basePath} render={props => <CrudList parentId={parentId} {...props} />}/>
            <Route exact path={basePath + '/:number/view'}
                   render={props => <CrudView parentId={parentId} {...props} />}/>
            <Route exact path={basePath + '/new'} render={props => <CrudEdit parentId={parentId} {...props} />}/>
        </Switch>
    );
};

export default SafetyDataSheetEvaluation;



// WEBPACK FOOTER //
// ./src/main/pages/SafetyDataSheetEvaluations.js